"use strict";
exports.__esModule = true;
exports.ToggleButton = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var text_1 = tslib_1.__importDefault(require("../text"));
var ToggleButton = function (_a) {
    var children = _a.children;
    return (react_1["default"].createElement("div", { className: 'w-full' },
        react_1["default"].createElement("div", { className: 'font-family-regular flex items-center justify-center h-full' },
            react_1["default"].createElement(text_1["default"], { typography: 'sm', color: "inherit" }, children))));
};
exports.ToggleButton = ToggleButton;
exports["default"] = exports.ToggleButton;
//# sourceMappingURL=toggle-button.js.map